var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputGameName")
                },
                model: {
                  value: _vm.searchData.game_name,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "game_name", $$v)
                  },
                  expression: "searchData.game_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("pleaseInputGameIdentifier")
                },
                model: {
                  value: _vm.searchData.game_mark,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "game_mark", $$v)
                  },
                  expression: "searchData.game_mark"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getData(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.handleSource()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("addGame")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", disabled: _vm.sels.length == 0 },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(_vm.selsString)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("batchDelete")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              prop: "id",
              label: _vm.$t("idLabel"),
              width: "60"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_name", label: _vm.$t("gameName") }
          }),
          _c("el-table-column", {
            attrs: { prop: "game_mark", label: _vm.$t("gameIdentifier") }
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("status") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 0
                      ? _c("span", { staticClass: "statusTag1" }, [
                          _vm._v(_vm._s(_vm.$t("disabled")))
                        ])
                      : _vm._e(),
                    row.status == 1
                      ? _c("span", { staticClass: "statusTag2" }, [
                          _vm._v(_vm._s(_vm.$t("normal")))
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operation"),
              width: "160",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDisable(
                                scope.row.id,
                                scope.row.status
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              scope.row.status == 0
                                ? _vm.$t("enabled")
                                : _vm.$t("disabled")
                            )
                          )
                        ]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleSource(scope.row.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("modify")))]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDelete(scope.row.id)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("delete")))]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.searchData.page,
          total: _vm.total
        },
        on: { "size-change": _vm.sizeChange, "current-change": _vm.getData }
      }),
      _c("addGames", {
        ref: "addGames",
        on: {
          change: function($event) {
            return _vm.getData(_vm.searchData.page)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }